"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignedMicroOrganisms = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var DesignedMicroOrganisms = (function (_super) {
    __extends(DesignedMicroOrganisms, _super);
    function DesignedMicroOrganisms() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.DESIGNED_MICRO_ORGANISMS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MICROBE],
            cost: 16,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(-14).max(); }),
            metadata: {
                cardNumber: '155',
                description: 'It must be -14 C or colder. Increase your Plant production 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(2); });
                }),
            },
        }) || this;
    }
    DesignedMicroOrganisms.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    };
    return DesignedMicroOrganisms;
}(Card_1.Card));
exports.DesignedMicroOrganisms = DesignedMicroOrganisms;
//# sourceMappingURL=DesignedMicroOrganisms.js.map